import styled from '@emotion/styled';
// eslint-disable-next-line no-restricted-imports
import { Checkbox } from '@workday/canvas-kit-react';
import { WcpStyles } from '@workday/wcp-tokens';

const StyledWrapper = styled.div({
  label: {
    color: WcpStyles.color.text.default,
  },
});

export const ThemedCheckbox: React.FC<React.ComponentProps<typeof Checkbox>> = (props) => (
  <StyledWrapper>
    <Checkbox {...props} />
  </StyledWrapper>
);
